import LoginPage from './LoginPage';

function index() {
	return (
		<div>
			<LoginPage />
		</div>
	);
}

export default index;
